<template>
  <div class="header">
      <div>
        <img src="../../assets/images/logo_s@4x.png" class="logo" @click="goHome">
      </div>
      <div class="rightImgs" @mouseover="mouseOver" @mouseleave="mouseLeave">
        <img :src="avatarPath ? baseUrl + avatarPath : defaultAvatar" class="userImg">
        <img src="../../assets/images/bottomSJ.png" alt="">
        <div v-if="flag" class="sign" @click=sign>退出登录</div>
      </div>
      <el-dialog title="提示" :append-to-body="true" :visible.sync="dialogVisible" width="30%">
        <span>确定要退出该账号吗？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="setLogin">确 定</el-button>
        </span>
      </el-dialog>
    </div>
</template>
<script>
  import {
    serverUrl
  } from '@/utils/server.js'
  import {
    getLogout
  } from '@/api/api'
  export default {
    data() {
      return {
        dialogVisible: false,
        flag: false,
        baseUrl: serverUrl.baseURL,
        avatarPath: '',
        defaultAvatar: require('../../assets/images/-s-mrtx.png')
      }
    },
    watch: {
    	val: {
    		handler() {
          this.avatarPath = this.val
    		},
    		immediate: true
    	}
    },
    props: ['val'],
    created() {
      var user = JSON.parse(localStorage.getItem('user'))
      if (user && user.avatarPath) {
        this.avatarPath = user.avatarPath
      }
    },
    methods: {
      sign() {
        this.dialogVisible = true
      },
      setLogin() {
        getLogout().then(res => {
          localStorage.removeItem('user')
          this.$router.push({
            path: '/platlogin'
          })
        }).catch(err => {
          localStorage.removeItem('user')
          this.$router.push({
            path: '/platlogin'
          })
        })
      },
      mouseOver() {
        this.flag = true
      },
      mouseLeave() {
        this.flag = false
      },
      goHome() {
        this.$router.push({
            path: '/home'
          })
      }
    }
  }
</script>
<style scoped>
  .header {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #282F3D;
    padding: 0 40px 0 20px;
    box-sizing: border-box;
  }

  .logo {
    /* width: 317px; */
    height: 45px;
    cursor: pointer;
  }

  .userImg {
    width: 55px;
    height: 55px;
    border-radius: 50%;
  }

  .rightImgs {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 150px;
    height: 80px;
  }

  .rightImgs > img {
    margin-left: 10px;
    cursor: pointer;
  }

  .sign {
    width: 150px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #fff;
    position: absolute;
    bottom: -50px;
    background: #161821;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/console/header.vue